import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import { getEnvironment } from '../../../../shared/utils/helpers';

const mutation = graphql`
  mutation CloseJobMutation($input: CloseJobInput!) {
    closeJob(input: $input) {
      job {
        status
        deliverables {
          edges {
            node {
              state
            }
          }
        }
      }
    }
  }
`;

const CloseJobMutation = (id, callback) => {
  commitMutation(getEnvironment(), {
    mutation,
    variables: { input: { id } },
    onCompleted: response => {
      callback(response.closeJob);
    },
    onError: err => console.error(err)
  });
};

export default CloseJobMutation;
